import AddUserInstution from "../components/admin/institution/AddUserInstution";
import Admin from "./Admin";

const AddUserToInstution = () => {
    return ( <Admin>
        <AddUserInstution/>
    </Admin> );
}
 
export default AddUserToInstution;